import dynamic from 'next/dynamic';

export const SecurePayment = dynamic(() => import('./SecurePayment').then(module => module.SecurePayment), {
  ssr: false,
});
